import { useState, useEffect } from 'react';
import { clinicasService } from '../services/clinicas.service';

interface DateSelectionProps {
  clinicaId: number;
  selectedDate?: string;
  onDateSelect: (date: string) => void;
  className?: string;
}

export default function DateSelection({
  clinicaId,
  selectedDate,
  onDateSelect,
  className = ''
}: DateSelectionProps) {
  const [availableDates, setAvailableDates] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadAvailableDates();
  }, [clinicaId]);

  const loadAvailableDates = async () => {
    if (!clinicaId) return;
    
    setLoading(true);
    try {
      const dates = await clinicasService.getProximasDatasDisponiveis(clinicaId, 60);
      // Converter formato YYYY-MM-DD para DD/MM/YYYY
      const formattedDates = dates.map(date => {
        if (date.includes('-')) {
          const [year, month, day] = date.split('T')[0].split('-');
          return `${day}/${month}/${year}`;
        }
        return date;
      });
      setAvailableDates(formattedDates);
    } catch (error) {
      console.error('Erro ao carregar datas disponíveis:', error);
      setAvailableDates([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Datas Disponíveis
        </h3>
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
          <span className="ml-2 text-gray-600">Carregando datas...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Próximas Datas Disponíveis
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Selecione uma data para agendar o exame do colaborador
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
        {availableDates.map((date) => {
          const isSelected = selectedDate === date;
          const dateParts = date.split('/');
          const day = dateParts[0];
          const month = dateParts[1];
          const year = dateParts[2];

          return (
            <button
              key={date}
              onClick={() => onDateSelect(date)}
              className={`p-3 text-center border rounded-lg transition-all duration-200 hover:shadow-md ${
                isSelected
                  ? 'border-green-500 bg-green-50 text-green-700 shadow-md'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
              }`}
            >
              <div className="text-2xl font-bold">{day}</div>
              <div className="text-xs text-gray-500">
                {new Date(`${year}-${month}-${day}`).toLocaleDateString('pt-BR', { month: 'short' })}
              </div>
              <div className="text-xs text-gray-400">{year}</div>
            </button>
          );
        })}
      </div>

      {availableDates.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          Nenhuma data disponível no momento
        </div>
      )}
    </div>
  );
}


